import BlueEye from "../../components/assets/eyes/BlueEye";
import PinkEye from "../../components/assets/eyes/PinkEye";
import Heading from "../../components/layout/Heading";
import ProjectFalling from "../ProjectFalling";

export default function ContactPage() {
    return (
        <>
            <div className="w-full max-w-[1470px] mx-auto min-h-[390px] flex flex-col justify-center mobile:px-8">
                <div className="w-full relative py-16 mobile:py-32">
                    <Heading
                        title="Il est temps de bosser ensemble !"
                        subtitle="On te laisse finir ton café et on t’attend pour un call ! On est déjà impatient de commencer ton projet !" />
                    <div className="w-[6.25rem] absolute right-0 top-0 -scale-x-[1] rotate-[10deg]">
                        <PinkEye version={1}/>
                    </div>
                    <div className="w-[6.25rem] absolute left-0 bottom-0] -rotate-[10deg]">
                        <BlueEye version={3}/>
                    </div>
                </div>
            </div>
            <ProjectFalling/>
        </>
    )
}